module.exports = __webpack_public_path__ + "static/media/street5.c03b0272.jpg";